module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp123_0.0d8b9a91.png";